import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../../utils/metaPixel';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
  trackCheckout?: boolean;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel,
  trackCheckout = false
}: ButtonProps) {
  const styles = {
    primary: 'bg-gold text-navy shadow-sm transition-[background-color,transform] hover:bg-gold-hover active:scale-[0.98]',
    secondary: 'border border-gray-300 bg-white text-navy shadow-sm transition-[background-color,transform] hover:bg-pearl active:scale-[0.98]',
    outline: 'border-2 border-aqua bg-transparent text-aqua transition-colors hover:bg-aqua-soft'
  };
  const sizes = {
    sm: 'px-5 py-3 text-sm',
    lg: 'px-7 py-4 text-base sm:px-10 sm:py-5 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-semibold duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 ${styles[variant]} ${sizes[size]} ${className}`;
  const handleClick = () => {
    if (trackCheckout) trackInitiateCheckout();
    onClick?.();
  };
  if (href) {
    return <a href={href} target={target} rel={rel} onClick={handleClick} className={classes} aria-label={ariaLabel} data-id="element-200" data-mp="xoie35ze6noi">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-201" data-mp="1ccd7kol84w2n" />}
      </a>;
  }
  return <button type="button" onClick={handleClick} className={classes} aria-label={ariaLabel} data-id="element-202" data-mp="17e1wybn3uhjd">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-203" data-mp="1lew8h35g8ym9" />}
    </button>;
}